import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

// The 30-second layer: the three highest-priority actions.
export default function DoNext({ doNext }) {
  const navigate = useNavigate();
  if (!doNext?.actions?.length) return null;
  return (
    <div className="card p-6 sm:p-7" data-testid="do-next">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-bold tracking-tight text-ink">What should I do next?</h2>
        <span className="label-caps">Highest impact</span>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {doNext.actions.map((a, i) => (
          <motion.button key={a.id} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.06 }}
            onClick={() => navigate(`/app${a.route}`)} data-testid={`do-next-${a.id}`}
            className="text-left rounded-2xl p-5 border transition-all hover:-translate-y-0.5" style={{ borderColor: "#E7E8E4", background: "#fff" }}>
            <div className="flex items-center justify-between">
              <span className="grid place-items-center w-8 h-8 rounded-full text-sm font-extrabold" style={{ background: "var(--grad-ink)", color: "#fff" }}>{i + 1}</span>
              <span className="inline-flex items-center gap-1 text-xs font-extrabold" style={{ color: "#5F8213" }}>+{a.gain}</span>
            </div>
            <p className="text-sm font-semibold text-ink mt-3 leading-snug">{a.instruction}</p>
            <span className="text-sm font-semibold inline-flex items-center gap-1 mt-3 text-ink">Do this <ArrowRight size={14} strokeWidth={2} /></span>
          </motion.button>
        ))}
      </div>
      <div className="mt-4 rounded-xl px-4 py-3 text-sm font-semibold flex items-center gap-2" style={{ background: "rgba(147,192,32,.08)", color: "#5F8213" }}>
        Complete these three actions → potential <span className="font-extrabold">+{doNext.combined_gain} Growth points</span>
      </div>
    </div>
  );
}
